import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const getInitial = () => {
    switch (direction) {
      case 'up':
        return {
          opacity: 0,
          y: 40
        };
      case 'down':
        return {
          opacity: 0,
          y: -40
        };
      case 'left':
        return {
          opacity: 0,
          x: 40
        };
      case 'right':
        return {
          opacity: 0,
          x: -40
        };
      default:
        return {
          opacity: 0
        };
    }
  };
  const getAnimate = () => {
    switch (direction) {
      case 'up':
        return {
          opacity: 1,
          y: 0
        };
      case 'down':
        return {
          opacity: 1,
          y: 0
        };
      case 'left':
        return {
          opacity: 1,
          x: 0
        };
      case 'right':
        return {
          opacity: 1,
          x: 0
        };
      default:
        return {
          opacity: 1
        };
    }
  };
  return <motion.div ref={ref} initial={getInitial()} animate={isInView ? getAnimate() : getInitial()} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-184">
      {children}
    </motion.div>;
}